import Vue from 'vue'

// 用于map组件与滚动列表、折线图组件联动
export const relateBus = new Vue()

export const richTextBus = new Vue()

export const socketBus = new Vue()
